// extracted by mini-css-extract-plugin
module.exports = {"carousel":"Carousel_carousel__1MFgS","items":"Carousel_items__2Cdxm","item":"Carousel_item__3qaht","image":"Carousel_image__2iwDi"};